// @flow
import { createSelector } from 'reselect';
import { getOption, type Option } from '../form/select.js';
import { organizationSelector } from '../organization/organization.selectors.js';

export const productsSelector = createSelector(
  state => state.products,
  (products: $ElementType<ReduxState, 'products'>): $ElementType<ReduxState, 'products'> => products
);

export const productFormSelector = createSelector(
  state => state.productForm,
  (productForm: $ElementType<ReduxState, 'productForm'>): $ElementType<ReduxState, 'productForm'> =>
    productForm
);

export const productsListSelector = createSelector(
  productsSelector,
  (products: $ElementType<ReduxState, 'products'>): List => Object.keys(products)
);

export const productsCreditListSelector = createSelector(
  productsSelector,
  organizationSelector,
  (products: $ElementType<ReduxState, 'products'>, org): List =>
    Object.keys(products).filter(
      id => products[id].organizationId === org.id && !products[id].trash
    )
);

export const productsOptionsSelector = createSelector(
  productsSelector,
  productsCreditListSelector,
  (products: $ElementType<ReduxState, 'products'>, list: List): Option[] =>
    list.reduce((acc, id) => acc.concat(getOption(products[id].name, id)), [])
);
